module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-left",
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('div', {
    staticClass: "logo",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-menu"
  }), _vm._v(" "), _c('span', [_vm._v("App")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-down",
    style: ({
      backgroundColor: _vm.keystone.config.app.color
    })
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    class: _vm.keystone.config.app.icon + ' icon-c-logo'
  }), _vm._v(" "), _c('span', [_vm._v("App")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.hover) ? _c('ul', {
    staticClass: "selection"
  }, _vm._l((_vm.keystone.config.app.interfaces), function(app) {
    return _c('li', {
      key: app.to,
      style: ({
        backgroundColor: app.color
      }),
      on: {
        "click": function($event) {
          return _vm.goToBilling(app.to)
        }
      }
    }, [_c('i', {
      class: app.icon
    })])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6f6b1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/TopBar/Logo.vue
// module id = 728
// module chunks = 1